import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import '../assets/css/Header.css';

function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    const handleScroll = () => {
      const header = document.querySelector('.header');
      if (header) {
        if (window.scrollY > 50) {
          header.classList.add('scrolled');
        } else {
          header.classList.remove('scrolled');
        }
      }
    };

    window.addEventListener('resize', checkMobile);
    window.addEventListener('scroll', handleScroll);
    
    return () => {
      window.removeEventListener('resize', checkMobile);
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  // دالة لإغلاق القائمة عند الضغط على أحد الروابط أو زر الإغلاق
  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  return (
    <header className="header">
      <div className="header-content">
        
        <a href="/" className="logo" onClick={closeMenu}>
          <img src="/images/image.png" alt="Logo" />
        </a>

        {/* يتم عرض هذا الجزء فقط في شاشات الجوال */}
        {isMobile && (
          // هذا الزر مسؤول فقط عن فتح القائمة
          <button 
            className="hamburger-btn" 
            onClick={() => setIsMenuOpen(true)}
            aria-label="Open menu"
          >
            ☰
          </button>
        )}

        {/* القائمة للديسكتوب */}
        {!isMobile && (
            <nav className='navbar-desktop'>
                <ul>
                    <li><a href="#faq">الأسئلة الشائعة</a></li>
                      <li><a href="#contact">تواصل معنا</a></li>
                       <li><Link to="/careers">فرص العمل</Link></li>
                             <li><a href="#service">الخدمات</a></li>
                                <li><a href="#about">عنّا</a></li>
                    <li><Link to="/">الصفحة الرئيسية</Link></li>
                 
              
                   
                  
                  
                </ul>
            </nav>
        )}

      </div>

      {/* قائمة الموبايل تظهر فقط في وضع الجوال */}
      {isMobile && (
        <nav className={`navbar-mobile ${isMenuOpen ? 'active' : ''}`}>
            {/* زر الإغلاق الجديد داخل القائمة */}
            <button className="close-menu-btn" onClick={closeMenu}>✕</button>
            <ul>
                <li><Link to="/" onClick={closeMenu}>الصفحة الرئيسية</Link></li>
                <li><a href="#about" onClick={closeMenu}>عنّا</a></li>
                <li><a href="#service" onClick={closeMenu}>الخدمات</a></li>
                <li><Link to="/careers" onClick={closeMenu}>فرص العمل</Link></li>
                <li><a href="#contact" onClick={closeMenu}>تواصل معنا</a></li>
                <li><a href="#faq" onClick={closeMenu}>الأسئلة الشائعة</a></li>
            </ul>
        </nav>
      )}

    </header>
  );
}

export default Header;